// src/middleware/permissionMiddleware.js
import { useContext, useEffect } from "react";
import { ContextGlobal } from "../context";
import Loading from "../components/loading";
import CardMessage from "../components/cards/message";
import { useNavigate } from "react-router-dom";

export const STATUS_LIBERADO = ["ATIVO", "DEMO", "FREE"];

export function PermissionUser({ modulo, app, empresa, children, hasButton = true }) {
	const { loadingPermissions, listPermissionsData, modulopermitted, fetchPermissions } = useContext(ContextGlobal);

	useEffect(() => {
		fetchPermissions();
		// }
	}, []); // roda só n

	const navigate = useNavigate();

	// early returns podem vir DEPOIS de ler o contexto (nenhum outro hook aqui)
	if (loadingPermissions) {
		return (
			<div className="mt-page">
				<Loading />
			</div>
		);
	}

	const noUser = !listPermissionsData || Object.keys(listPermissionsData).length === 0;

	if (noUser) {
		return (
			<CardMessage
				title="Usuário não encontrado, Verifique sua conexão com internet e tente novamente."
				hasButton={hasButton}
				textButton="Tentar Novamente"
				type={0}
				// callBackFunction={() => (window.location.href = "/login")}
				callBackFunction={() => window.location.reload()}
				className="mt-page"
			/>
		);
	}

	if (empresa && listPermissionsData?.id_empresa !== empresa) {
		return (
			<CardMessage
				title="Acesso restrito."
				hasButton={hasButton}
				textButton="Voltar"
				type={403}
				callBackFunction={() => window.history.back()}
				className="mt-page"
			/>
		);
	}

	// verifica se todos os módulos estão expirados
	const allExpired = (modulopermitted ?? []).every((item) => item.status === "EXPIRADO");

	const firstExpired = (modulopermitted ?? []).find((item) => item.status === "EXPIRADO");

	if (allExpired && modulo !== "unattached") {
		let message = "Sua licença para uso está vencida.";

		// if (firstExpired?.dias_restantes >= 0) {
		// 	message = `Sua licença está expirada - ${firstExpired.dias_restantes ?? 0} dias restantes`;
		// }

		return (
			<>
				<CardMessage
					title={message}
					hasButton={hasButton}
					textButton="Saiba mais"
					type={402}
					callBackFunction={() => navigate("/invoice-viewer")}
					className="mt-page"
				/>
			</>
		);
	}

	const allDemoExpired = (modulopermitted ?? []).every((item) => item.status === "DEMO_EXPIRADO");

	if (allDemoExpired) {
		let message = "A demonstração terminou. Clique em Assinar para seguir utilizando todos os recursos.";

		// if (firstExpired?.dias_restantes >= 0) {
		// 	message = `Sua licença está expirada - ${firstExpired.dias_restantes ?? 0} dias restantes`;
		// }

		return (
			<>
				<CardMessage
					title={message}
					hasButton={hasButton}
					textButton="Assinar"
					type={402}
					callBackFunction={() => window.dispatchEvent(new CustomEvent("StoreConfirmation"))}
					className="mt-page"
				/>
			</>
		);
	}

	const appLiberado =
		!app || (modulopermitted ?? []).some((item) => item.modulo === app && STATUS_LIBERADO.includes(item.status));

	if (!appLiberado) {
		return (
			<CardMessage
				title="Seu plano não inclui este módulo."
				hasButton={hasButton}
				textButton="Ver minha fatura"
				type={402}
				callBackFunction={() => navigate("/invoice-viewer")}
				className="mt-page"
			/>
		);
	}

	let hasPermission = Boolean(listPermissionsData?.[modulo] ?? false);
	// unattached é permitido para todos
	// unattached1 é a tela principal o index foi colocado 1 pq precisava validar o fatura tb
	if (modulo === "unattached" || modulo === "unattached1") {
		hasPermission = true;
	}

	if (!hasPermission) {
		return (
			<CardMessage
				title="Você não tem permissão para acessar esta página."
				hasButton={hasButton}
				textButton="Voltar"
				type={403}
				callBackFunction={() => window.history.back()}
				className="mt-page"
			/>
		);
	}

	return <>{children}</>;
}
